module.exports = __webpack_public_path__ + "img/img_display_4.133239d7.svg";